import MemberNameTableData from './MemberInfo';

export default MemberNameTableData;
